// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipV2_tooltip__oQkDG","positionRelative":"tooltipV2_positionRelative__CEMbu","tooltipContent":"tooltipV2_tooltipContent__rNIoj","triangle":"tooltipV2_triangle__SjU2Y"};